// import headerTemplate from './template/heade-template.pug';
import sortableHeaderTemplate from './template/sortable-header-template.pug';
import { ProjectionGridBaseColumn, mergeClasses, COLUMN_TYPES, COLUMN_FORMATS, mapColumnsConfig } from './column';

// Export Sortable Header Template
export {
  ProjectionGridBaseColumn,
  mergeClasses,
  COLUMN_TYPES,
  COLUMN_FORMATS,
  sortableHeaderTemplate,
  mapColumnsConfig,
};
